import LoginPage from '../@react-fefmwk/theme-structure/modules/layouts/LoginPage'
import StandardPage from '../@react-fefmwk/theme-structure/modules/layouts/StandardPage'
import FullWidthPage from '../@react-fefmwk/theme-structure/modules/layouts/FullWidthPage'
import EmbedPage from '../@react-fefmwk/theme-structure/modules/layouts/EmbedPage'
import FullWidthNoNavPage from '../@react-fefmwk/theme-structure/modules/layouts/FullWidthNoNavPage'
import StandardPageNoNavSideMenu from '../@react-fefmwk/theme-structure/modules/layouts/StandardPageNoNavSideMenu'

import Login from '../pages/Login'
import ForgotPassword from '../pages/ForgotPassword'
import ResetPassword from '../pages/ResetPassword'
import Profile from '../pages/Profile'
//import Settings from '../pages/Settings'

import HomePage from '../pages/HomePage'

export const AppSchema = {
    "login": {
        "matchRules": ["/","/forgot-password","/reset-password"],
        "layout": LoginPage,
        "layoutProps": {
            "appStyle":{"backgroundImage": "url('/images/login-background.png')"}
        },
        "routes": [
            {
                "slug": "login",
                "visibility": "public",
                "path": "/",
                "title": "Login",
                "component": Login,
                "users_can": [],
                "groups_can": [],
                "props": {
                    "redirectTo": "/home"
                }
            },
            {
                "slug": "forgot-password",
                "visibility": "public",
                "path": "/forgot-password",
                "title": "Ripristina password",
                "component": ForgotPassword,
            },
            {
                "slug": "reset-password",
                "visibility": "public",
                "path": "/reset-password",
                "title": "Reset password",
                "component": ResetPassword,
            },
        ],
    },
    "pagenonavside": {
        "matchRules": ["/home","/profile"],
        "layout": StandardPageNoNavSideMenu,
        "routes": [
            {
                "slug": "home",
                "visibility": "private",
                "path": "/home",
                //"title": "Gestioni Patrimoniali",
                "component": HomePage,
                "props": {},
                "users_can": [],
                "groups_can": [],
            },
            {
                "slug": "profile",
                "visibility": "private",
                "path": "/profile",
                "title": "Profile",
                "component": Profile,
                "users_can": [],
                "groups_can": [],
            },
            /* {
                "slug": "settings",
                "visibility": "private",
                "path": "/settings",
                "title": "Settings",
                "component": Settings,
                "users_can": [],
                "groups_can": [1],
            }, */
        ],
    },
    "fullwidthnonavpage": {
        "matchRules": [],
        "layout": FullWidthNoNavPage,
        "routes": [],
    },
    "embed": {
        "matchRules": [],
        "layout": EmbedPage,
        "routes": [],
    },
    "fullwidthpage": {
        "matchRules": [],
        "layout": FullWidthPage,
        "routes": [],
    },
    "page": {
        "matchRules": [],
        "layout": StandardPage,
        "routes": [],
    },
}